import React from 'react'

import { reverse } from 'named-urls'
import { Link as RouterLink, useHistory } from 'react-router-dom'
import { RHFInput } from 'react-hook-form-input'
import * as yup from 'yup'
import useForm from 'react-hook-form'
import clsx from 'clsx'

import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Paper,
  TextField,
  makeStyles,
} from '@material-ui/core'

import { routes } from 'routes'
import { InputCurrency } from 'components/Form'
import CustomizedSnackbars from 'components/Snackbar'
import * as service from 'service'
import helpers from 'helpers'

const useStyles = makeStyles(theme => ({
  button: {
    marginRight: theme.spacing(1),
  },
  marginBottom: {
    marginBottom: '10px',
  },
  rowInput: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  input: {
    marginRight: theme.spacing(2),
  },
}))

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .max(50, 'Nome deve conter no máximo 50 caracteres'),
  description: yup.string().required(),
  code: yup
    .string()
    .required()
    .max(100, 'Código deve conter no máximo 100 caracteres'),
  periodicity: yup
    .number()
    .required()
    .positive()
    .integer(),
  price: yup
    .number()
    .required()
    .min(0, 'O valor precisa ser maior ou igual a R$ 0,00'),
})

const PlansForm = ({ planId, ...props }) => {
  const history = useHistory()
  const classes = useStyles()
  const { handleSubmit, register, setValue, errors } = useForm({
    defaultValues: props.plan || { price: 0 },
    validationSchema: schema,
  })
  const [open, setOpen] = React.useState(false)
  const [plan, setPlan] = React.useState(props.plan)
  const [errorResponse, setErrorResponse] = React.useState(undefined)

  React.useEffect(() => {
    setPlan(props.plan)
  }, [props.plan])

  const handleOpenChange = event => {
    const value = event.target.value
    setOpen(value)
  }

  const onSubmit = async plan => {
    try {
      if (props.plan) {
        await service.recurrence.plans.put({ planId, plan })
        Object.keys(plan).map(key => setValue(key, plan[key]))
        history.push(reverse(routes.plans.show, { planId }))
      } else {
        await service.recurrence.plans.create({ plan })
        history.push(routes.plans.all)
      }
    } catch (e) {
      setErrorResponse(e)
      setOpen(true)
    }
  }

  return (
    <Paper>
      {errorResponse && (
        <CustomizedSnackbars
          variant="error"
          open={open}
          onChange={handleOpenChange}
          message={errorResponse.response.data.error.message}
        ></CustomizedSnackbars>
      )}

      <Box p={2}>
        <form onSubmit={handleSubmit(onSubmit)} id="plan-create-form">
          <TextField
            label="Nome"
            margin="dense"
            name="name"
            inputRef={register}
            error={errors.name !== undefined}
            helperText={errors.name ? errors.name.message : ''}
            fullWidth
          />
          <TextField
            label="Descrição"
            margin="dense"
            name="description"
            rows="4"
            inputRef={register}
            error={errors.description !== undefined}
            helperText={errors.description ? errors.description.message : ''}
            fullWidth
            multiline
          />
          <TextField
            label="Código único do plano"
            margin="dense"
            name="code"
            inputRef={register}
            error={errors.code !== undefined}
            helperText={errors.code ? errors.code.message : ''}
            fullWidth
          />
          <div className={classes.rowInput}>
            <RHFInput
              as={
                <TextField
                  label="Periodicidade"
                  className={clsx(classes.marginBottom, classes.input)}
                  SelectProps={{ native: true }}
                  size="small"
                  margin="dense"
                  select
                  error={errors.periodicity !== undefined}
                  helperText={
                    errors.periodicity
                      ? errors.periodicity.message
                      : 'Periodicidade da cobrança (de quanto em quanto tempo será cobrado?)'
                  }
                  fullWidth
                >
                  <option></option>
                  {helpers.plans.periodicityOptions.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </TextField>
              }
              name="periodicity"
              register={register}
              setValue={setValue}
              mode="onChange"
            />
            <RHFInput
              as={
                <InputCurrency
                  label="Valor"
                  margin="dense"
                  fullWidth
                  error={!!errors.price}
                  helperText={errors && errors.price && errors.price.message}
                />
              }
              name="price"
              register={register}
              setValue={setValue}
              mode="onChange"
            />
          </div>
          <FormControlLabel
            control={
              <Checkbox
                type="checkbox"
                name="suggested"
                defaultChecked={props.plan ? props.plan.suggested : false}
                inputRef={register}
              />
            }
            label="Destacar plano na página de contratação"
          />
        </form>
      </Box>
      <Divider />
      <Box p={2}>
        <Button
          color="primary"
          variant="contained"
          type="submit"
          form="plan-create-form"
          className={classes.button}
        >
          {plan ? 'Salvar' : 'Cadastrar'}
        </Button>
        <Button
          variant="outlined"
          color="primary"
          component={RouterLink}
          to={
            plan
              ? reverse(routes.plans.show, { planId: planId })
              : routes.plans.all
          }
        >
          Cancelar
        </Button>
      </Box>
    </Paper>
  )
}

export default PlansForm
